
import storageService from '../../../Infrustructure/localStorageService'

const service = {
    read: function () {
        return JSON.parse(storageService.getItem("returnInfo")) || [];
    },
    write: function (info) {
        storageService.setItem("returnInfo", JSON.stringify(info));
    },
    clear: function () {
        storageService.removeItem("returnInfo");
    },
}

export default service;



// WEBPACK FOOTER //
// ./src/components/application/ProductReturn/service.js